import { render, staticRenderFns } from "./TaskMediasList.vue?vue&type=template&id=08e83cd4&scoped=true"
import script from "./TaskMediasList.vue?vue&type=script&lang=js"
export * from "./TaskMediasList.vue?vue&type=script&lang=js"
import style0 from "./TaskMediasList.vue?vue&type=style&index=0&id=08e83cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e83cd4",
  null
  
)

export default component.exports